import React from 'react';
import { overrideTailwindClasses } from 'tailwind-override';

interface Props {
  icon: React.ReactNode;
  label: React.ReactNode;
  isSelected?: boolean;
  value: any;
  onClick?: () => void;
}

const ProfileMenuItem = (props: Props) => {
  return (
    <div
      className={overrideTailwindClasses(
        ` hover:bg-secondary-50 dark:hover:bg-white/5 soft-transition p-4 rounded-xl my-2 cursor-pointer flex space-x-4 items-center ${
          props.isSelected
            ? 'bg-secondary-50 text-secondary-700 dark:bg-white/10 dark:text-secondary-200'
            : 'text-inkMuted dark:text-inkMuted-dark'
        }`
      )}
      onClick={props.onClick}
    >
      {props.icon}
      <span className="font-medium text-sm">{props.label}</span>
    </div>
  );
};

export default ProfileMenuItem;
